/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "context";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// Anaytics dashboard components
import SalesByCountry from "layouts/dashboards/analytics/components/SalesByCountry";

import crudsService from "services/cruds-service";
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";
import GroupBy from "helper/group-by";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import { Card } from "@mui/material";
import MDDatePicker from "components/MDDatePicker";
import MDButton from "components/MDButton";
import FilterForm from "./components/filter";

function ProjectAnalytics() {
  const { setIsAuthenticated, getCurrentUser } = useContext(AuthContext);
  const [projectChartData, setProjectChartData] = useState();
  const [projectTableData, setProjectTabledata] = useState([]);
  const [txnResultChartData, setTxnResultChartData] = useState();

  useEffect(() => {
    async function checkToken() {
      let user = await getCurrentUser();
      if (!user) {
        setIsAuthenticated(false);
        localStorage.removeItem("token");
      }
    }
    checkToken();
  }, []);

  const prebareChartObj = (arr, labelTxt, dataTxt, getMonthName = false) => {
    let labels = [];
    let data = [];
    for (const key in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, key)) {
        const element = arr[key];
        let label;
        if (getMonthName) {
          label = getMonthNameInArabic(element[labelTxt]);
        } else {
          label = element[labelTxt];
        }
        labels.push(label);
        data.push(element.sum[dataTxt]);
      }
    }

    return { labels, data };
  };

  // const prebareTableObj = (arr) => {
  //   const groupedArr = GroupBy(arr, "project");
  //   let newArr = [];
  //   let suc;
  //   let fil;
  //   for (let key in groupedArr) {
  //     if (Object.hasOwn(groupedArr, key)) {
  //       suc = groupedArr[key].filter((f) => f.TxnResult === "Success")[0];
  //       fil = groupedArr[key].filter((f) => f.TxnResult === "Failed")[0];
  //       newArr.push({
  //         المشروع: key,
  //         " عدد العمليات الفاشلة": fil?.count.id || 0,
  //         " عدد العمليات الناجحة": suc?.count.id || 0,
  //         " قيمة العمليات الفاشلة": fil?.sum.PurchAmount || 0,
  //         " قيمة العمليات الناجحة": suc?.sum.PurchAmount || 0,
  //       });
  //     }
  //   }
  //   return newArr;
  // };

  const prebareTableObj = (arr) => {
    const groupedArr = GroupBy(arr, "project");
    let rows = [];
    let suc;
    let fil;
    for (let key in groupedArr) {
      if (Object.hasOwn(groupedArr, key)) {
        suc = groupedArr[key].filter((f) => f.TxnResult === "Success")[0];
        fil = groupedArr[key].filter((f) => f.TxnResult === "Failed")[0];
        rows.push({
          country: key,
          countFil: (fil?.count.id || 0) + "",
          countSuc: (suc?.count.id || 0) + "",
          valFil: (fil?.sum.PurchAmount || 0) + "",
          valSuc: (suc?.sum.PurchAmount || 0) + "",
        });
      }
    }
    let columns = [
      { accessor: "country", Header: "المشروع", width: "25%" },
      {
        accessor: "countSuc",
        Header: "عدد العمليات الناجحة",
        width: "30%",
      },
      { accessor: "valSuc", Header: "قيمة العمليات الناجحة" },
      {
        accessor: "countFil",
        Header: "عدد العمليات الفاشلة",
        width: "12%",
      },
      { accessor: "valFil", Header: "قيمة العمليات الفاشلة", width: "12%" },
    ];
    return { columns, rows };
  };

  async function getProjects(f = "") {
    const donationProjectTableData = await crudsService.donationCharts(
      "project,TxnResult",
      f,
      "donation_items"
    );
    let ptd = prebareTableObj(
      donationProjectTableData.data,
      "project",
      "PurchAmount"
    );

    setProjectTabledata(ptd);

    //charts data
    const donationProjectsChartsData = await crudsService.donationCharts(
      "project",
      `filter[ProcReturnCode][_eq]=00${f ? `&${f}` : ""}`,
      "donation_items"
    );

    setProjectChartData(
      prebareChartObj(donationProjectsChartsData.data, "project", "PurchAmount")
    );

    const donationTxnResultChartsData = await crudsService.donationCharts(
      "TxnResult",
      f,
      "donation_items"
    );

    setTxnResultChartData(
      prebareChartObj(
        donationTxnResultChartsData.data,
        "TxnResult",
        "PurchAmount"
      )
    );
  }

  useEffect(() => {
    getProjects();
  }, []);

  const getTabel = useCallback(
    () => (
      <SalesByCountry
        data={projectTableData}
        title="التبرعات على مشروع"
        color="secondary"
      />
    ),
    [projectTableData]
  );

  return (
    <DashboardLayout>
      <FilterForm getProjects={getProjects} keyword={"donation_items"} />
      <MDBox py={3}>
        <Grid container>{getTabel()}</Grid>
        <Grid container spacing={3} pt={5}>
          <Grid item xs={12} md={6} lg={4}>
            {txnResultChartData && (
              <DefaultDoughnutChart
                icon={{ color: "secondary", component: "signposticon" }}
                title="حالة التبرعات"
                description=""
                chart={{
                  labels: txnResultChartData.labels,
                  datasets: {
                    label: "التبرعات",
                    backgroundColors: [
                      "error",
                      "dark",
                      "success",
                      "info",
                      "secondary",
                      "primary",
                      "warning",
                    ],
                    data: txnResultChartData.data,
                  },
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            {projectChartData && (
              <VerticalBarChart
                icon={{ color: "secondary", component: "engineeringicon" }}
                title="التبرعات مع المشاريع"
                description=""
                chart={{
                  labels: projectChartData.labels,
                  datasets: [
                    {
                      label: "التبرعات",
                      color: "secondary",
                      data: projectChartData.data,
                    },
                  ],
                }}
              />
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProjectAnalytics;
